/**
 * Opens a summerwood.com URL by submitting a POST form rather than navigating
 * to it.
 *
 * Adding to a wishlist clones a configuration and all of its gallery rows, so
 * summerwood.com only accepts it over POST. The API hands us that destination
 * as a plain URL, and its query string uses ';' as the separator rather than
 * '&', which is the convention on that side.
 */
export const openAsPost = (url: string, target = '_blank'): void => {
  const split = url.indexOf('?');
  const action = split === -1 ? url : url.slice(0, split);
  const query = split === -1 ? '' : url.slice(split + 1);

  const form = document.createElement('form');
  form.method = 'post';
  form.action = action;
  form.target = target;

  query
    .split(/[;&]/)
    .filter(Boolean)
    .forEach((pair) => {
      const eq = pair.indexOf('=');
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = decodeURIComponent(eq === -1 ? pair : pair.slice(0, eq));
      input.value = eq === -1 ? '' : decodeURIComponent(pair.slice(eq + 1));
      form.appendChild(input);
    });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
